
export enum TripNodeStatusCd {
	ASSIGNED = 'Assigned',
	COMPLETED = 'Completed',
	PENDING = 'Pending',
	PRE_ASSIGNED = 'PreAssigned'}

